













































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { client, xml } from '@xmpp/client';
// import debug from '@xmpp/debug';
import XGplayer from '@/components/XGplayer.vue';
import { Popup, Icon, Swipe, SwipeItem, Toast } from 'vant';
import lazyLoad from 'vue-lazyload';
import { isWeiXin, isMobile, isJSON, replaceAllImg } from '@/common/ts/common';
import {
  getUnionId,
  getBaseInfo,
  getGiftStore,
  sendGiftApi,
  genXmppUser,
  submitComment,
  getHistoryComments,
} from '../api';

Vue.use(Popup)
  .use(Icon)
  .use(Swipe)
  .use(SwipeItem)
  .use(Toast)
  .use(lazyLoad, {
    loading:
      'https://image2.cqcb.com/d/file/topics/activity/2020-05-11/Ap8Rg9oj-img-place-holder_cr.png',
  });

let xmpp: any = null;
const liveVideoCovers = [
  'https://image2.cqcb.com/d/file/topics/activity/2020-06-09/1591699787883.jpg',
  'https://image2.cqcb.com/d/file/topics/activity/2020-06-09/1591699811031.jpg',
  'https://image2.cqcb.com/d/file/topics/activity/2020-06-09/1591699827966.jpg',
];
const otherVideoCovers = [
  'https://image2.cqcb.com/d/file/topics/activity/2020-06-09/1591699731423.jpg',
  'https://image2.cqcb.com/d/file/topics/activity/2020-06-09/1591699760333.jpg',
  'https://image2.cqcb.com/d/file/topics/activity/2020-06-09/1591699678573.jpg',
  'https://image2.cqcb.com/d/file/topics/activity/2020-07-13/ZI7oJddP-1594633903504.jpg',
];
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

@Component({
  name: 'LiveRoom',
  components: {
    XGplayer,
  },
})
export default class LiveRoom extends Vue {
  roomBaseInfo: any = {};
  comments: any[] = [];
  historyComments: any[] = [];
  historyCommentLastOneId: string | number = 0;
  loading = false;
  finished = false;
  userInput = '';
  tabContentHeight = 0;
  giftIndex = 0;
  tabTitles = ['评论互动', '本场介绍', '文档分享', '更多精彩'];
  giftStore: any[] = [];
  showGiftStore = false;
  showConfIntro = false;
  giftQueue: any[] = [];
  activeGiftTimer: any = null;
  activeGiftTimerB: any = null;
  giftTick = 1;
  giftsWrapperY = 0;
  activeTabIndex = 0;
  wxUserInfo: any = {};
  isUserSentMessage = false;
  isWechatEnv = false;
  inputAreaHeight = 0;
  activeInnerTabIndex = 0;
  sharedFiles: any[] = [];
  moreVideo: any[] = [];
  chatListHeight = 0;
  scrollTimer: any = null;
  commentsIsScrollBottom = false;
  commentsIsScrollTop = false;
  showNewMessageTip = false;
  viewerNumber = 0;
  defaultAvatar =
    'https://image2.cqcb.com/d/file/topics/activity/2019-11-20//sy_news/composition/1574231593901_defaultAvatar.png';

  get restWordCount() {
    const MAX_LEN = 60;
    return MAX_LEN - this.userInput.length;
  }

  @Watch('chatListHeight')
  onChatListHeightChange(newval: number, oldval: number) {
    if (this.commentsIsScrollTop && document.querySelector('.comment-item')) {
      (this.$refs.chatListWrapper as HTMLDivElement).scrollTop =
        newval -
        oldval -
        (document.querySelector('.comment-item') as HTMLDivElement)
          .clientHeight;
    }
  }
  @Watch('comments')
  onCommentsChange() {
    const chatListEl = this.$refs.chatList as HTMLDivElement;
    const chatListWrapperEl = this.$refs.chatListWrapper as HTMLDivElement;
    console.log(
      'compare:',
      Math.abs(
        chatListWrapperEl.scrollTop -
          (chatListEl.scrollHeight - chatListWrapperEl.clientHeight),
      ),
    );
    if (
      Math.abs(
        chatListWrapperEl.scrollTop -
          (chatListEl.scrollHeight - chatListWrapperEl.clientHeight),
      ) <= this.tabContentHeight
    ) {
      console.log('do something');
      setTimeout(() => {
        chatListWrapperEl.scrollTop = chatListWrapperEl.scrollHeight;
      }, 50);
    } else {
      this.showNewMessageTip = true;
    }
  }
  // 计算数据渲染完成后的聊天室高度
  @Watch('roomBaseInfo', { deep: true })
  onRoomBaseInfoChange() {
    this.$nextTick(() => {
      this.getChatRoomHeight();
    });
  }
  beforeRouteEnter(to: any, from: any, next: any) {
    if (isWeiXin()) {
      if (!to.query.code && !localStorage.getItem('gbwxUserInfo')) {
        // 模拟微信授权跳转
        const appId = 'wxd272511640b931e3';
        location.href = `http://wx.chongqingexpo.com?appid=${appId}&redirect_uri=${encodeURIComponent(
          location.href,
        )}&response_type=code&scope=snsapi_userinfo&state=expo-auth#wechat_redirect`;
      } else if (localStorage.getItem('gbwxUserInfo')) {
        next(($vm: LiveRoom) => {
          const userWxInfo = JSON.parse(
            localStorage.getItem('gbwxUserInfo') as any,
          );
          $vm.wxUserInfo = userWxInfo;
        });
      } else {
        getUnionId(to.query.code).then((res: any) => {
          if (res.code === 200) {
            localStorage.setItem('gbwxUserInfo', JSON.stringify(res.data));
            next(($vm: LiveRoom) => {
              $vm.wxUserInfo = res.data;
            });
          }
        });
      }
    } else {
      next();
    }
  }

  async created() {
    console.log('wodetiannawxUserInfo', this.wxUserInfo);
    this.isWechatEnv = isWeiXin();
    // 获取当场直播基础信息
    const baseInfoRet = await getBaseInfo(this.$route.params.roomNumber);
    // 获取其他两场直播基础信息
    const liveRoomIds = [1, 2, 3];
    const ret = await Promise.all(
      liveRoomIds.map((item: number) => getBaseInfo(item)),
    );
    const moreVideoUrl = `${process.env.VUE_APP_PUBLIC_PATH}cq-expo-hotpot-live/`;
    const mappedLiveRoomInfos = ret
      .map((item: any, index: number) => ({
        title: item.data.title,
        desc: item.data.subtitle,
        cover: liveVideoCovers[index],
        start_time: item.data.start_time * 1000,
        url: `${moreVideoUrl}room/${index + 1}`,
        showInVideoList: false,
      }))
      .filter(
        (item: any, index: number) =>
          index + 1 !== Number(this.$route.params.roomNumber),
      );
    // 不需要在直播间展示的视频
    const otherVideos = [
      {
        cover: otherVideoCovers[0],
        desc: '悦动重庆，一切会更好',
        showInVideoList: false,
        start_time: 1577808000000,
        title: '大会先导片',
        url: `${moreVideoUrl}videos/1`,
      },
      {
        cover: otherVideoCovers[1],
        desc: '大道无穷，未来可期',
        showInVideoList: false,
        start_time: 1591632000000, // 6月9号放出
        title: '大会预告片',
        url: `${moreVideoUrl}videos/2`,
      },
      {
        cover: otherVideoCovers[2],
        desc: '往届大会精彩瞬间',
        showInVideoList: false,
        start_time: 1577808000000,
        title: '大会回顾片',
        url: `${moreVideoUrl}videos/3`,
      },
      {
        cover: otherVideoCovers[3],
        desc: '创新者大会背后的故事',
        showInVideoList: false,
        start_time: 1577808000000,
        title: '大会花絮篇',
        url: `${moreVideoUrl}videos/4`,
      },
    ];
    this.moreVideo = [...mappedLiveRoomInfos, ...otherVideos];
    baseInfoRet.data.videoCover =
      liveVideoCovers[Number(this.$route.params.roomNumber) - 1];
    this.roomBaseInfo = baseInfoRet.data;
    this.sharedFiles = [
      {
        guestname: this.roomBaseInfo.file_one_name,
        content: replaceAllImg(this.roomBaseInfo.file_one_content),
      },
      {
        guestname: this.roomBaseInfo.file_two_name,
        content: replaceAllImg(this.roomBaseInfo.file_two_content),
      },
      {
        guestname: this.roomBaseInfo.file_three_name,
        content: replaceAllImg(this.roomBaseInfo.file_three_content),
      },
    ];
    if (isWeiXin()) {
      Toast.loading({
        message: '连接中...',
        duration: 0,
      });
      // 生成xmpp用户账号
      const genXmppUserRet = await genXmppUser(
        {
          unionid: this.wxUserInfo.openId,
        },
        this.$route.params.roomNumber,
      );
      if (!genXmppUserRet) {
        return Toast('Sorry, 你暂时无法进入互动');
      }
      const serviceUrl = process.env.VUE_APP_XMPP_SERVER;
      // 设置xmpp客户端
      xmpp = client({
        service: serviceUrl,
        username: this.wxUserInfo.openId,
        password: `HotPotLive${this.wxUserInfo.openId}`,
        resource: 'expo-hotpot-live',
      });
      // 拿到用户凭据和房间信息后初始化聊天室
      this.initChatRoom();
    }
    // 处理礼物橱窗数据
    this.renderGiftStore();
    // 轮询更新观看人数
    this.updateViewerNumber();
    setInterval(() => {
      this.updateViewerNumber();
    }, 60 * 1000);
  }
  async mounted() {
    await this.loadHistoryComments();
    this.$nextTick(() => {
      setTimeout(() => {
        (this.$refs.chatListWrapper as HTMLDivElement).scrollTo(
          0,
          (this.$refs.chatList as HTMLDivElement).scrollHeight,
        );
      }, 800);
      setTimeout(() => {
        // this.commentsIsScrollBottom = false;
      }, 1500);
    });
    // 监听chatList滚动
    (this.$refs.chatListWrapper as HTMLDivElement).addEventListener(
      'scroll',
      () => {
        if (this.scrollTimer) {
          clearTimeout(this.scrollTimer);
        }
        this.scrollTimer = setTimeout(() => {
          const chatListHeight = (this.$refs.chatList as HTMLDivElement)
            .scrollHeight;
          const chatListWrapperHeight = (this.$refs
            .chatListWrapper as HTMLDivElement).clientHeight;
          console.log(
            'chatList==>scrollTop:',
            (this.$refs.chatListWrapper as HTMLDivElement).scrollTop,
            Math.abs(
              (this.$refs.chatListWrapper as HTMLDivElement).scrollTop -
                (chatListHeight - chatListWrapperHeight),
            ),
          );
          const isBottom =
            Math.abs(
              (this.$refs.chatListWrapper as HTMLDivElement).scrollTop -
                (chatListHeight - chatListWrapperHeight),
            ) <= 5;
          this.commentsIsScrollBottom = isBottom;
          if (isBottom) {
            this.showNewMessageTip = false;
          }
          // 判断顶部
          if ((this.$refs.chatListWrapper as HTMLDivElement).scrollTop <= 2) {
            this.commentsIsScrollTop = true;
          } else {
            this.commentsIsScrollTop = false;
          }
        }, 100);
      },
    );
  }

  onLoadMoreCommentsClick() {
    this.loadHistoryComments();
  }

  async loadHistoryComments() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    const ret = await getHistoryComments({
      page: 1,
      liveType: this.$route.params.roomNumber,
      id: this.historyCommentLastOneId || '',
    });
    this.loading = false;
    if (ret.data && ret.data.length) {
      this.historyCommentLastOneId = ret.data[0].commentId;
      this.historyComments = ret.data.concat(this.historyComments);
    } else {
      this.finished = true;
    }
    // console.log(ret.data[0].commentId)
    this.$nextTick(() => {
      this.chatListHeight =
        (this.$refs.chatList as HTMLDivElement).scrollHeight + 20;
    });
  }

  // 计算chatRoom(tab content容器)高度
  getChatRoomHeight() {
    const playerHeight = (this.$refs.player as Vue).$el.clientHeight;
    const roomTitleHeight = (this.$refs.roomTitle as HTMLDivElement)
      .clientHeight;
    const inputAreaHeight = (this.$refs.inputArea as HTMLElement).clientHeight;
    const tabsHeight = (this.$refs.tabs as HTMLElement).clientHeight;
    const tabContentHeight = playerHeight + roomTitleHeight + tabsHeight + 10;
    // console.log(playerHeight, roomTitleHeight, tabsHeight, inputAreaHeight);
    this.tabContentHeight = tabContentHeight;
    this.inputAreaHeight = inputAreaHeight;
    // console.log(playerHeight, roomTitleHeight, vantTabsHeight.clientHeight);
  }

  // 初始化聊天室
  initChatRoom() {
    xmpp.on('error', (err: any) => {
      console.error('connect error occur:', err);
      Toast(JSON.stringify(err));
    });
    xmpp.on('offline', () => {
      console.log('offline');
    });

    xmpp.on('stanza', async (stanza: any) => {
      console.log(stanza.is('message'), 'sysy');
      if (stanza.is('message')) {
        console.log(stanza.toString());
        const message = stanza.clone();
        const messageText = message.getChildText('body');
        // 后台消息均以JSON数据返回
        if (messageText && !isJSON(messageText)) {
          console.log('this is not json data');
        } else if (messageText && isJSON(messageText)) {
          const data = JSON.parse(messageText);
          // console.log(data);
          if (
            (data.msg === 'comment' &&
              data.data.openid !== this.wxUserInfo.openId) ||
            (!this.isUserSentMessage && data.msg === 'comment')
          ) {
            this.comments.push(data.data);
          } else if (data.msg === 'add-food') {
            const defaultGiftIcon =
              'http://image2.cqcb.com/d/file/C8pPp2MvtEGHs3EK5yYzqmMsNJ7CGrTw7hgzPJoU.png';
            this.renderGift({
              foodname: data.data.foodname,
              icon: data.data.cover || defaultGiftIcon,
              sender: data.data.nickname || '吃瓜群众',
              receiver: data.data.guestname,
            });
            // 同时在评论区显示插入礼物消息
            this.comments.push({
              isGift: true,
              nickname: data.data.nickname,
              content: `给${data.data.guestname}送出一份${data.data.foodname}`,
              headImg: data.data.headimg,
              openid: data.data.openid,
              foodImg: data.data.cover,
            });
          }
        }
        if (document.querySelector('.comment-item')) {
          this.chatListHeight +=
            (document.querySelector('.comment-item') as HTMLDivElement)
              .clientHeight + 15;
        }
      }
    });

    xmpp.on('online', async (address: any) => {
      // Makes itself available
      Toast.clear();
      console.log('online', address.toString());
      // !加入房间，注意需要在房间地址后跟上用户昵称
      await xmpp.send(
        xml('presence', {
          to: this.roomBaseInfo.xmppRomm + `/${this.wxUserInfo.openId}`,
          // type: 'unavailable',
        }),
      );
    });

    xmpp.start().catch(console.error);
    // xmpp end
    // 微信页面销毁时断开xmpp连接
    window.addEventListener('pagehide', async () => {
      // 微信环境中关闭页面事件为pagehide，此处关闭xmpp通信
      await xmpp.send(
        xml('presence', {
          to: this.roomBaseInfo.xmppRomm + `/${this.wxUserInfo.openId}`,
          type: 'unavailable',
        }),
      );
      xmpp.stop();
    });
  }
  // 处理礼物橱窗数据
  async renderGiftStore() {
    // 处理底部gift store菜单数据
    const foodListRet = await getGiftStore();
    const mappedData = foodListRet.data.map((item: any) => ({
      id: item.id,
      icon: item.cover,
      text: item.title,
    }));
    const finalResult = [];
    // console.log('base info is:', baseInfo, foodList);
    for (let j = 0; j < mappedData.length; j += 8) {
      finalResult.push(mappedData.slice(j, j + 8));
    }
    this.giftStore = finalResult;
  }
  // 开关礼物橱窗
  toggleGiftStore() {
    if (!this.isWechatEnv) {
      return Toast('请在微信参与~');
    }
    this.showGiftStore = !this.showGiftStore;
  }
  // 开关大会介绍弹窗
  toggleConfIntro() {
    // ! 此处为模拟打赏测试代码
    // const defaultGiftIcon =
    //   'http://image2.cqcb.com/d/file/C8pPp2MvtEGHs3EK5yYzqmMsNJ7CGrTw7hgzPJoU.png';
    // this.renderGift({
    //   foodname: '司马',
    //   icon: defaultGiftIcon,
    //   sender: '吃瓜群众',
    //   receiver: '黑哥',
    // });
    // this.comments.push({
    //   isGift: true,
    //   nickname: '吃瓜群众',
    //   content: `给黑哥送出一份司马`,
    //   headImg: '',
    //   openid: 'xxx',
    //   foodImg:
    //     'http://image2.cqcb.com/d/file/C8pPp2MvtEGHs3EK5yYzqmMsNJ7CGrTw7hgzPJoU.png',
    // });
    // this.chatListHeight +=
    //   (document.querySelector('.comment-item') as HTMLDivElement).clientHeight +
    //   15;
    // return;
    this.showConfIntro = !this.showConfIntro;
  }
  // 渲染礼物飞入
  renderGift(giftData: any) {
    const { sender, foodname, icon, receiver } = giftData;
    const data = {
      sender,
      foodname,
      icon,
      receiver,
      id: +new Date(),
    };
    if (this.giftQueue.length >= 2) {
      this.giftQueue.shift();
      if (this.activeGiftTimer) {
        clearTimeout(this.activeGiftTimer);
      }
      this.activeGiftTimer = setTimeout(() => {
        this.giftQueue.push(data);
      }, 500);
    } else {
      this.giftQueue.push(data);
    }
    // 清除礼物通知
    if (this.activeGiftTimerB) {
      clearTimeout(this.activeGiftTimerB);
    }
    this.activeGiftTimerB = setTimeout(() => {
      this.giftQueue = [];
    }, 2500);
  }
  // api发送礼物
  async sendGift(giftData: any) {
    if (new Date().getTime() >= Number(this.roomBaseInfo.end_time) * 1000) {
      return Toast('本场直播互动已结束~');
    } else if (
      new Date().getTime() <
      Number(this.roomBaseInfo.start_time) * 1000
    ) {
      return Toast('本场直播互动未开始~');
    }
    // 送礼完成后关闭礼物弹窗
    this.toggleGiftStore();
    if (this.activeGiftTimer) {
      console.log('clear active gift timer');
      clearTimeout(this.activeGiftTimer);
    }
    const userWxInfo = JSON.parse(localStorage.getItem('gbwxUserInfo') as any);
    const userNickName = userWxInfo ? userWxInfo.nickname : '吃瓜群众';
    const retSendGift: any = await sendGiftApi(
      {
        foodname: giftData.text,
        nickname: userNickName,
        unionid: this.wxUserInfo.openId,
        headimg: this.wxUserInfo.headimgurl,
      },
      this.$route.params.roomNumber,
    );
    if (retSendGift.code !== 200) {
      Toast(retSendGift.msg);
    }
  }
  // 处理tab切换高亮
  onTabChange(tabIndex: number) {
    this.activeTabIndex = tabIndex;
  }
  // 处理文档分享tab切换高亮
  onInnerTabChange(tabIndex: number) {
    this.activeInnerTabIndex = tabIndex;
  }
  // 发送评论
  async onSubmit() {
    if (!this.userInput) {
      return;
    } else if (
      new Date().getTime() >=
      Number(this.roomBaseInfo.end_time) * 1000
    ) {
      return Toast('本场直播互动已结束~');
    } else if (
      new Date().getTime() <
      Number(this.roomBaseInfo.start_time) * 1000
    ) {
      return Toast('本场直播互动未开始~');
    }
    // 发送消息后立即失焦关闭软键盘
    (this.$refs.inputEl as HTMLInputElement).blur();
    this.comments.push({
      nickname: this.wxUserInfo.nickname || '吃瓜群众',
      headImg: this.wxUserInfo.headimgurl,
      content: this.userInput,
      openid: this.wxUserInfo.openId,
    });
    // ! 走api审核通道发送用户评论
    const retSubmitComment = await submitComment(
      {
        unionid: this.wxUserInfo.openId,
        nickname: this.wxUserInfo.nickname,
        headImg: this.wxUserInfo.headimgurl,
        content: this.userInput,
      },
      this.$route.params.roomNumber,
    );
    this.userInput = '';
    this.isUserSentMessage = true;
    console.log('ret of comment api:', retSubmitComment);
  }
  // 退出直播间返回上个页面栈
  // exitLive() {
  //   history.back();
  // }
  // 处理限制于微信环境中的操作
  onInputAreaClick() {
    if (!this.isWechatEnv) {
      Toast('请在微信参与~');
    }
  }
  // iOS设备中失焦后
  onInputBlur() {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
      window.scrollTo(0, 0);
    }
  }
  onMoreVideoItemClick(videoItem: any) {
    // check视频是否可看
    const currentTime = new Date().getTime();
    if (currentTime - videoItem.start_time >= 0) {
      location.href = videoItem.url;
    } else {
      Toast('敬请期待');
    }
  }
  // 滚动到最新消息
  scrollToLatestMessage() {
    (this.$refs.chatListWrapper as HTMLDivElement).scrollTo(
      0,
      (this.$refs.chatList as HTMLDivElement).scrollHeight,
    );
  }
  // 轮询更新观看人数
  async updateViewerNumber() {
    const ret = await getBaseInfo(this.$route.params.roomNumber);
    this.viewerNumber = ret.data.pv;
  }
}
